'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HashHistory = require('react-history/HashHistory');

var _HashHistory2 = _interopRequireDefault(_HashHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _HashHistory2['default'];


//////////////////
// WEBPACK FOOTER
// ./program/frontend/components/history/index.js
// module id = 777
// module chunks = 0